import { Expand } from 'lucide-react'
import { Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui'

import { ProductSelectionResult, ProductItem } from './types'
import { useLocalization } from 'src/shared/hooks/useLocalization'

interface ProductSelectionMessageProps {
  quote_id: number
  result: ProductSelectionResult
  onOpenOverlay?: (
    products: ProductItem[],
    quote_id: number,
    product_categories?: string[]
  ) => void
}

export const ProductSelectionMessage = ({
  quote_id,
  result,
  onOpenOverlay,
}: ProductSelectionMessageProps) => {
  const products = result?.results || []
  const product_categories = result?.product_categories || []
  const { t } = useLocalization()

  if (!products || products.length === 0) {
    return null
  }

  return (
    <Button
      size="sm"
      variant="secondary"
      onClick={() => onOpenOverlay?.(products, quote_id, product_categories)}
      className="opacity-70 mt-2 mb-1 heartbeat-border-3"
    >
      <Row className="items-center gap-1.5">
        {t('Show all results', 'Visa alla resultat')}{' '}
        <Expand className="w-3 h-3" />
      </Row>
    </Button>
  )
}
